import React from "react";
import { FormattedMessage } from "react-intl";
import { withRouter } from "react-router-dom";
import { Pages } from "../config";

const BackButton = withRouter(({ history }) => (
  <button className="btn btn-primary btn-fill" onClick={() => history.goBack()}>Go Back</button>
));

export default (props) => {
  return (
    <React.Fragment>
      <h1 className="page-title"><FormattedMessage id="verificationRequired.title" defaultMessage="Verification Required"/></h1>
      <Pages.VerificationDetails />
      <br />
      <BackButton />
    </React.Fragment>
  );
};
